module.exports = __webpack_public_path__ + "static/media/Fir St, South San Francisco, CA1.29fae214.jpg";